// extracted by mini-css-extract-plugin
export default {"container":"BaseLayout_container__wHiE1","main":"BaseLayout_main__y9eID"};